import React from 'react'

import * as S from './styles'

import Header from "../../molecules/Header";
import NavBar from "../../molecules/NavBar";
import MainContent from "../../molecules/MainContent";
import Footer from "../../molecules/Footer";
import Txt from '../../atoms/Txt'
import ProfileCardMenu from "../../organisms/ProfileCardMenu";

function userSecurity() {
  return (
    <S.Container>
      <Header />
      <NavBar />
      <MainContent>
        <S.UserSoldContainer>
          <ProfileCardMenu />
          <S.UserSoldRightContainer>
            <S.UserSecurityTitle>
              <i className="fas fa-lock" />
                            SEGURANÇA
                        </S.UserSecurityTitle>
            <S.MsgFunctionality>
              INICIO DE SEÇÃO
                        </S.MsgFunctionality>
            <S.UserSecuritySettingsContainer>
              <div className='user-status-config-row'>
                <div className='container-left'>
                  <i className="far fa-envelope" />
                </div>
                <div className='container-right'>
                  <p>E-mail</p>
                  <span>silva.anderson@gmail.com</span>
                </div>
              </div>
              <div className='user-status-config-row'>
                <div className='container-left'>
                  <i className="fas fa-user-alt" />
                </div>
                <div className='container-right'>
                  <p>Usuario</p>
                  <span>Anderson Silva</span>
                </div>
              </div>
              <div className='user-status-config-row'>
                <div className='container-left'>
                  <i className="fas fa-key" />
                </div>
                <div className='container-right'>
                  <p>Senha</p>
                  <span>************</span>
                </div>
              </div>
            </S.UserSecuritySettingsContainer>
            <S.UserSoldContainerBot>
              <i className="fas fa-lock" />
              <div>
                <div className='verification-mode'>
                  <Txt size="22px" color="black">Métodos de verificação</Txt>
                  <Txt color='#514d4d' style={{ marginTop: '-8px' }}>Selecione um método de verificação
                                        para adicionar uma camada a mais de segurança a sua conta.</Txt>
                </div>
                <div className='msg-status'>
                  <Txt size="18px" color="black">Verificação em 2 etapas</Txt>
                  <Txt size="18px" color="green" style={{ marginLeft: '8px' }}>ATIVADA</Txt>
                </div>
              </div>
            </S.UserSoldContainerBot>
          </S.UserSoldRightContainer>
        </S.UserSoldContainer>
      </MainContent>
      <S.Foote>
        <Footer />
      </S.Foote>
    </S.Container>
  )
}

export default userSecurity;
